import * as createFocusTrap  from 'focus-trap';

const elements = {
  navToggleContainer: document.body.querySelector(".c-navigation__toggle-container"),
  navigation: document.body.querySelector(".js-navigation-alt-2"),
  panel: document.body.querySelector(".js-navigation-alt-panel"),
  panelMenu: document.body.querySelector(".js-navigation-panel-menu"),
  parentLinks: document.body.querySelectorAll(".js-navigation-parent-link"),
  dropdownLinks: document.body.querySelectorAll(".js-navigation-dropdown-link"),
  buttons: document.body.querySelectorAll(".js-navigation__button"),
  returnTriggers: document.body.querySelectorAll(
    ".js-navigation-return-trigger"
  ),
  trigger: document.body.querySelector(".js-navigation-alt-trigger"),
};

const traps = {
  first: null,
  second: null,
  third: null
}

let currentTrapLevel = null;

function activateLevelTrap(level, targets, focusEl = null) {

  if (!traps[level]) {
    setTimeout(() => {
      traps[level] = createFocusTrap.createFocusTrap(targets, {
        initialFocus: focusEl || targets[0],
        clickOutsideDeactivates: true,
        allowOutsideClick: true,
        escapeDeactivates: false,
      });
      traps[level].activate();
    }, 100);
  }

  currentTrapLevel = level;
}

function resetTraps() {
  Object.keys(traps).forEach((trap) => {
      traps[trap] && traps[trap].deactivate(false);
      traps[trap] = null
  });
  currentTrapLevel = null;
}

function resetDrawers() {
  const activeDrawers = document.body.querySelectorAll(".drawer-is-active");
  const secondLevel = document.body.querySelectorAll(".second-level-active");
  const thirdLevel = document.body.querySelectorAll(".third-level-active");
  activeDrawers.forEach(drawer => drawer.classList.remove("drawer-is-active"));
  secondLevel.forEach(level => level.classList.remove("second-level-active"));
  thirdLevel.forEach(level => level.classList.remove("third-level-active"));
}

const active = "is-active";
function toggleNavigation() {
  setNavigationHeight();
  elements.trigger.classList.toggle(active);
  elements.panel.classList.toggle(active);

  document.body.classList.toggle("nav-is-active");

  if (!document.body.classList.contains("nav-is-active")) {
    elements.buttons.forEach((item) => {
      item.innerHTML = "+";
      item.ariaExpanded = "false";
    });

    resetDrawers();
    resetTraps();
  } else {
    activateLevelTrap("first", [elements.navigation, elements.navToggleContainer], elements.trigger);
  }
}

function setNavigationHeight() {
  const header = document.querySelector('.c-header').clientHeight;
  elements.panel.style.height = window.innerHeight - header + 'px';
}

function toggleDropdown(item, parentClass) {
  item.parentNode.classList.toggle(parentClass);

  if (item.parentNode.classList.contains(parentClass)) {
    item.innerHTML = "-";
    item.ariaExpanded = "true";
  } else {
    item.innerHTML = "+";
    item.ariaExpanded = "false";
  }
}

function init() {
  if (elements.navigation !== null) {
    setNavigationHeight();
    window.addEventListener("resize", () => {
      if (!document.body.classList.contains("nav-is-active")) return;
      toggleNavigation();
    });
    document.addEventListener("click", (element) => {
      if (!elements.panel.classList.contains(active)) return;
      if (
        elements.panel.contains(element.target) ||
        element.target === elements.trigger
      )
        return;
      toggleNavigation();
    });

    elements.trigger.addEventListener("click", toggleNavigation);

    Array.prototype.forEach.call(elements.parentLinks, (item) => {
      item.addEventListener("click", (event) => {
        if (!item.parentElement.classList.contains(active)) {
          event.preventDefault();
        }
        
        elements.panel.scrollTop = 0;
        if (
          item.parentNode.classList.contains("c-navigation__item--first-level")
        ) {
          
          elements.panelMenu.classList.add("second-level-active");
          item.parentNode.classList.add("drawer-is-active");
          const drawer = item.parentNode.querySelector('.c-navigation__drawer');
          const returnTrigger = item.parentNode.querySelector(".js-navigation-return-trigger > button");
          activateLevelTrap("second", [drawer, elements.navToggleContainer], returnTrigger);
        }
        if (
          item.parentNode.classList.contains("c-navigation__item--second-level")
        ) {
          elements.panelMenu.classList.add("third-level-active");
          item.parentNode.classList.add("drawer-is-active");
          const drawer = item.parentNode.querySelector('.c-navigation__drawer');
          const returnTrigger = item.parentNode.querySelector(".js-navigation-return-trigger > button");
          activateLevelTrap("third", [drawer, elements.navToggleContainer], returnTrigger);
        }
      
      });
    });

    Array.prototype.forEach.call(elements.dropdownLinks, (item) => {
      const secondLevelLinks = document.querySelectorAll(
        ".js-navigation-second-level-parent"
      );
      item.addEventListener("mouseover", () => {
        item.classList.add("dropdown-is-active");
        document.body.classList.add("nav-is-active");

        if (!secondLevelLinks.length) return;
        secondLevelLinks.forEach((link) => {
          link.addEventListener("mouseover", () => {
            secondLevelLinks.forEach((el) => el.classList.remove(active));
            link.classList.add(active);
          });
          link.parentElement.parentElement.addEventListener(
            "mouseleave",
            () => {
              secondLevelLinks.forEach((el) => el.classList.remove(active));
            }
          );
        });
      });

      item.addEventListener("mouseleave", () => {
        item.classList.remove("dropdown-is-active");
        document.body.classList.remove("nav-is-active");
        elements.buttons.forEach((item) => {
          item.innerHTML = "+";
          item.ariaExpanded = "false";
        });
        if (!secondLevelLinks.length) return;
        secondLevelLinks.forEach((el) => el.classList.remove(active));
      });
    });

    Array.prototype.forEach.call(elements.buttons, (item) => {
      if (item.parentNode.classList.contains("js-navigation-dropdown-link")) {
        item.addEventListener("click", () => {
          toggleDropdown(item, "dropdown-is-active");
        });
      } else if (
        item.parentNode.classList.contains("js-navigation-second-level-parent")
      ) {
        item.addEventListener("click", () => {
          toggleDropdown(item, "is-active");
        });
      }
    });

    Array.prototype.forEach.call(elements.returnTriggers, (item) => {
      item.addEventListener("click", () => {
        item.parentNode.parentNode.parentNode.classList.remove(
          "drawer-is-active"
        );
        if (elements.panelMenu.classList.contains("third-level-active")) {
          elements.panelMenu.classList.remove("third-level-active");
          traps.third.deactivate();
          traps.third = null;
          activateLevelTrap("second");
        } else if (
          elements.panelMenu.classList.contains("second-level-active")
        ) {
          elements.panelMenu.classList.remove("second-level-active");
          traps.second.deactivate();
          traps.second = null;
          activateLevelTrap("first");
        }
        document.body
          .querySelectorAll(".js-drawer-list")
          .forEach((item) => (item.scrollTop = 0));
      });
    });
  }
}

export default init;



// WEBPACK FOOTER //
// ./src/components/components/consumer/navigation/navigation-off-canvas.js